import selectTicketPlans from '../../../shared/ticket_deals/selectTicketPlans'

export default function() {
  selectTicketPlans();
};
